
export class Indicator {
  total: number;
  onTarget: number;
  offTarget: number;
  percOnTarget: number;
  percOffTarget: number;
  average: string;
  type: IndicatorType;
}

export enum IndicatorType {
  TMO = 1,
  TME = 2,
  TMA = 3
}

